import axios from 'axios';
import Cookies from 'js-cookie';
import { push, replace } from 'connected-react-router';
import { getIsFromWorkspaceWithoutSessionId } from '@panel/commons/helpers/workspaceHelper';
import * as userDataTypes from '../ducks/userData/types';
import * as userTypes from '../ducks/user/types';

const siteId = process.env.REACT_APP_BUILD_SITE || 'ZPAR';

const apiConfig = {
  avisos: process.env.REACT_APP_API_PANEL,
  ecommerce: process.env.REACT_APP_API_ECOMMERCE,
  leads: process.env.REACT_APP_API_LEADS,
  panoramix: '',
  publicador: process.env.REACT_APP_API_PUBLICADOR,
  publicadorProf: process.env.REACT_APP_API_PUBLICADOR_PROF,
  publicadorImg: process.env.REACT_APP_API_PUBLICADOR_IMG,
  users: process.env.REACT_APP_API_USERS,
  pubr: process.env.REACT_APP_API_PUBR,
  integraciones: process.env.REACT_APP_API_INTEGRATIONS,
  landing: process.env.REACT_APP_API_LANDING
};

const instance = axios.create({
  timeout: 140000,
  headers: { 'Content-Type': 'application/json', 'x-panel-portal': siteId },
  withCredentials: true
});

function handleErrors(err, action, next) {
  const useEntireErr = action.type === userDataTypes.UPDATE_USER_DATA;

  next({
    type: `${action.type}_FAILED`,
    payload: useEntireErr ? err : err.response,
    meta: action.meta
  });

  if (action.navigateOnFail && err.response && err.response.status !== 401) {
    const navigationType = action.navigateOnFail.replace ? replace : push;
    next(navigationType(action.navigateOnFail.location));
  }

  const isFromWorkspaceWithoutSessionId = getIsFromWorkspaceWithoutSessionId(window.location.href);

  if (
    err.response &&
    err.response.status === 401 &&
    !isFromWorkspaceWithoutSessionId // &&
    // process.env.NODE_ENV !== 'development'
  ) {
    next({
      type: userTypes.SHOW_LOGIN,
      meta: {
        status: true
      }
    });
    // window.location = `/login/?redirect=${window.location.href}`;
  }

  if (err.response && err.response.status === 403) {
    next(push('/permissionserror'));
  }
}

function handleResponse(res, action, next) {
  const useEntireResponse = action.type === userDataTypes.UPDATE_USER_DATA;

  const { data } = res;
  next({
    type: `${action.type}_COMPLETED`,
    payload: useEntireResponse ? res : data,
    meta: action.meta
  });

  if (action.navigateOnSuccess) {
    const navigationType = action.navigateOnSuccess.replace ? replace : push;
    let navigate = action.navigateOnSuccess.location;

    if (data.postingId && !action.meta.saveAndExit) {
      navigate = { ...navigate, search: `?postingId=${data.postingId}` };
    }
    next(navigationType(navigate));
  }
  return res;
}

const apiService = () => next => action => {
  const result = next(action);
  if (!action.meta || !action.meta.async || action.meta.bulk) {
    if (action.navigateOnSuccess) {
      const navigationType = action.navigateOnSuccess.replace ? replace : push;
      next(navigationType(action.navigateOnSuccess.location));
    }
    return result;
  }

  const { path, method = 'GET', api = 'avisos', query, body, headers = {} } = action.meta;

  if (!path) {
    throw new Error(`'path' not specified for async action ${action.type}`);
  }

  const endpoint = apiConfig[api] + path;
  const sessionId = Cookies.get('sessionId') || '';

  return instance
    .request({
      url: endpoint,
      method,
      params: query,
      data: body,
      headers: { ...headers, sessionId }
    })
    .then(
      res => handleResponse(res, action, next),
      err => handleErrors(err, action, next)
    );
};

export { apiService, handleErrors, handleResponse, instance, apiConfig };
